export enum SystemVars {
  WT_PROMOTION_FLAG = "WT_PROMOTION_FLAG",
  WT_MALL_SERVICE_PHONE = "WT_MALL_SERVICE_PHONE",
  APP_ONLINE_PAYMENT_DATA = "APP_ONLINE_PAYMENT_DATA",
  APP_ONLINE_PAYMENT_INTERVAL_TIME = "APP_ONLINE_PAYMENT_INTERVAL_TIME",
  APP_ONLINE_PAYMENT_DATA_JA = "APP_ONLINE_PAYMENT_DATA_JA"
}
